/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, Platform } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { QuestionnaireSharedService } from 'src/app/services/questionnaire-shared.service';
import { Subscription } from 'rxjs';
import { BackButtonService } from 'src/app/services/back-button.service';

@Component({
  selector: 'app-question-comments',
  templateUrl: './question-comments.component.html',
  styleUrls: ['./question-comments.component.scss'],
})
export class QuestionCommentsPage implements OnDestroy {
  answerId: number;
  categoryKey: string;

  question: string;
  id: number;
  parentObject: string;
  customFormId: number;
  comments: any[];
  questionObject: any;
  savingProcess = false;
  noInternetConnection = false;
  routerState: any;
  comment = '';
  commentView = false;
  commentUpdateView = false;
  updateComment: any;
  editable = true;
  private loadingDialog: HTMLIonLoadingElement;
  private backButtonSubscription: Subscription;

  constructor(
    private dataService: DataProviderService,
    private route: ActivatedRoute,
    private loadingController: LoadingController,
    private questionnaireSharedService: QuestionnaireSharedService,
    private router: Router,
    private translatePipe: TranslatePipe,
    private platform: Platform,
    private backButtonService: BackButtonService
  ) {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.navigateToQuestionnairePage();
      },
    });
  }
  ionViewWillEnter(): void {
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.navigateToQuestionnairePage();
      },
    });
  }
  ngOnInit(): void {
    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(10, () => {
        this.navigateToQuestionnairePage();
      });
    this.route.params.subscribe((params) => {
      this.answerId = parseInt(params?.answerId, 10);
      this.parentObject = params?.parentObject;
      this.categoryKey = params?.categoryKey;
      this.question = params?.question;
      this.id = parseInt(params?.id, 10);
      this.customFormId = parseInt(params?.customFormId, 10);
      this.routerState = this.router.getCurrentNavigation().extras.state;
      this.editable = this.routerState?.editable ?? true;

      this.getQuestionComments(false);
    });
  }

  async getQuestionComments(changeQuestion: boolean) {
    await this.showLoading();
    this.dataService.getComments(this.parentObject, this.answerId).subscribe(
      (result) => {
        if (result !== 0) {
          this.noInternetConnection = false;
          this.comments = result;
          this.loadingDialog.dismiss();
          if (changeQuestion) {
            this.changeQuestionnaireObject();
          }
        } else {
          this.noInternetConnection = true;
          this.loadingDialog.dismiss();
          this.comments = [];
        }
      },
      (error) => {
        this.loadingDialog.dismiss();
      },
      () => {}
    );
  }

  cancel() {
    this.commentUpdateView = false;
    this.commentView = false;
  }
  handleUpdateComment(comment: any) {
    this.commentUpdateView = true;
    this.updateComment = comment;
  }

  handleAddComment() {
    this.commentView = true;
  }

  saveComment() {
    this.savingProcess = true;
    this.dataService
      .saveComment(this.parentObject, this.answerId, {
        Comment: this.comment,
      })
      .then((result) => {
        this.comments.unshift({ id: result.id, comment: this.comment });
        this.comment = '';
        this.commentView = false;
        this.savingProcess = false;

        this.changeQuestionnaireObject();
      })
      .catch((error) => {
        this.savingProcess = false;
        console.error(`save comment error: ${error.message}`);
      });
  }

  updateComments(Id: number) {
    this.savingProcess = true;

    this.dataService
      .updateComment(this.parentObject, Id, {
        Comment: this.updateComment.comment,
      })
      .then((result) => {
        this.comment = '';
        this.commentUpdateView = false;
        this.savingProcess = false;
      })
      .catch((error) => {
        this.savingProcess = false;
        console.error(`save comment error: ${error.message}`);
      });
  }

  deleteComment(commentId: number) {
    this.dataService
      .deleteComment(this.parentObject, commentId)
      .then((result) => {
        this.comments = this.comments.filter(
          (comment) => comment.id !== commentId
        );
        this.changeQuestionnaireObject();
      });
  }
  async showLoading() {
    this.loadingDialog = await this.loadingController.create({
      message: this.translatePipe.transform('LOADING'),
    });

    this.loadingDialog.present();
  }

  changeQuestionnaireObject() {
    const changeObject = {
      commentsCount: this.comments.length,
      answerId: this.answerId,
      categoryKey: this.categoryKey,
    };

    this.questionnaireSharedService.onNewCommentEvent.emit(changeObject);
  }

  navigateToQuestionnairePage() {
    this.router.navigate(
      ['questionnaire', this.customFormId, this.parentObject, this.id],
      {
        state: this.routerState,
      }
    );
  }

  ngOnDestroy() {
    this.backButtonSubscription?.unsubscribe();
  }
}
